import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    ViewChild
} from '@angular/core';
import { pluck, switchMap } from 'rxjs/operators';
import { forkJoin, from, fromEvent, Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DropboxService } from '../../dropbox/dropbox.service';
import { ToastService } from '../../services/toast/toast.service';

@Component({
    selector: 'sb-file-upload-area',
    templateUrl: './sb-file-upload-area.component.html',
    styleUrls: ['./sb-file-upload-area.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class SbFileUploadAreaComponent {
    @ViewChild('fileUpload', { static: true }) fileUpload: ElementRef<HTMLInputElement>;

    @Input() set select(value) {
        this._select = value;
        if (value) {
            this.fileUpload?.nativeElement.click();
        }
    }
    constructor(
        private http: HttpClient,
        private dropbox: DropboxService,
        private toast: ToastService
    ) {}
    unsubscribe$ = new Subject();
    isActive = false;
    defaultText = 'Drag and drop or click to upload new file(s)';
    activeText = 'Release to upload file(s)';
    text = this.defaultText;
    @Input() targetFolder;
    private _select;

    showFile(file) {
        let fileType = file.type;
        let validExtensions = ['image/jpeg', 'image/jpg', 'image/png'];
        // if file is an image file
        if (validExtensions.includes(fileType)) {
            let fileReader = new FileReader();
            fileReader.onload = () => {
                let fileURL = fileReader.result;
                let imgTag = `<img src="${fileURL}" alt="image">`;
                // show image?
            };
            fileReader.readAsDataURL(file);
        } else {
            // not an image
            this.isActive = false;
        }
    }

    fileName = '';
    uploadProgress: number;
    upload$: Observable<any>;

    dragover($event: DragEvent) {
        $event.preventDefault();
        this.text = this.activeText;
        this.isActive = true;
    }
    dragleave($event: DragEvent) {
        this.text = this.defaultText;
        this.isActive = false;
    }

    drop($event: DragEvent) {
        $event.preventDefault();
        if (!this.targetFolder) {
            return;
        }
        //const file = $event.dataTransfer.files[0];
        //this.showFile(file); //calling function
        const files = $event.dataTransfer.files;
        this.uploadFiles(this.targetFolder, files);
    }

    onFileSelected($event) {
        if (!this.targetFolder) {
            return;
        }
        //const file: File = $event.target.files[0];
        const files = $event.target.files;
        this.uploadFiles(this.targetFolder, files);
    }

    uploadFiles(folder: string, files: FileList) {
        forkJoin(
            Array.from(files).reduce((readFiles, file) => {
                const reader = new FileReader();
                reader.readAsArrayBuffer(file);
                return [
                    ...readFiles,
                    fromEvent(reader, 'loadend').pipe(
                        pluck('target', 'result'),
                        switchMap((contents) =>
                            from(this.dropbox.upload(folder, file.name, contents))
                        )
                    )
                ];
            }, [])
        ).subscribe((res) => {
            //console.log(res);
            // TODO: fix observable
            this.toast.show({ intent: 'success', message: 'File uploaded to dropbox!' });
        });
    }
}
